'use strict';

import parseAddress from 'addressparser';

export default function (addr) {
  let addresses = parseAddress(addr);
  return !!(addresses && addresses.length === 1 && addresses[0].address === addr);
}
